import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../storage/local-storage.service';
import { SessionStorageService } from '../storage/session-storage.service';

const INTERCEPTED_URLS = [environment.apiUrl, environment.pdfApiUrl];
const PUBLIC_INVITATION_PATH = '/auth/accept-invitation';
const ACCEPT_INVITATION_URL = `${environment.apiUrl}user/accept-invitation/`;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!INTERCEPTED_URLS.some((url) => req.url.startsWith(url))) {
      return next.handle(req);
    }

    let headers = req.headers.set(
      'Accept-Language',
      this.localStorageService.getLanguageFromLocalStorage() ?? 'en',
    );

    const isInvitationRequest = req.url.startsWith(ACCEPT_INVITATION_URL);
    const token = this.localStorageService.getTokenFromLocalStorage();
    if (token && !isInvitationRequest) {
      headers = headers.set('Authorization', `Token ${token}`);
    }

    if (!(req.body instanceof FormData) && !headers.has('Content-Type')) {
      headers = headers.set('Content-Type', 'application/json');
    }

    return next.handle(req.clone({ headers })).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.localStorageService.removeToken();
          this.sessionStorageService.removeUser();
          this.router.navigate(['/auth/login']);
        }
        const currentPath = this.router.url.split('?')[0];
        const currentUser = this.sessionStorageService.getUser();
        if (error instanceof HttpErrorResponse && error.status === 428 &&
            currentPath !== PUBLIC_INVITATION_PATH &&
            currentUser?.centerAdmin !== false) {
          this.router.navigate(['/auth/legal-acceptance']);
        }
        return throwError(() => error);
      }),
    );
  }
}
